import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { pendingResults, raceResults } from '../store/selectors/resultsSelectors';
import { getRaces } from '../store/reducers/Results/resultsSlice';
export const useResults = () => {
    const dispatch = useDispatch();
    const pending = useSelector(pendingResults);
    const results = useSelector(raceResults);
    useEffect(() => {
        if (!pending && !results) {
            dispatch(getRaces());
        }
    }, [dispatch, results, pending]);
    return { pending, results };
};
